import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Box, Text, Card, Flex, Button } from 'theme-ui'
import { Layout, Stack, Main } from '@layout'
import PageTitle from '@components/PageTitle'
import Divider from '@components/Divider'
import Section from '@components/Section'
import Seo from '@widgets/Seo'
import { Link } from 'gatsby'

/**
 * Shadow me to add your own content
 */

const styles = {
  imageWrapper: {
    borderRadius: `default`,
    overflow: `hidden`,
    position: `relative`
  },
  button: {
    display: [`none`, `block`],
    position: `absolute`,
    bottom: 4,
    right: 4
  },
  grid: {
    flexWrap: [`wrap`, `wrap`, `nowrap`],
    ' > div + div': {
      ml: [0, 0, 5]
    }
  },
  column: {
    flex: `auto`,
    flexBasis: [`full`, `full`, `1/2`]
  }
}

export default props => {
  const data = useStaticQuery(aboutQuery)

  const { photo } = data
  const { fluid } = (photo && photo.childImageSharp) || {}

  return (
    <Layout {...props}>
      <Seo title='About' />
      <Divider />
      <Stack>
        <Main>
          <PageTitle
            header='About Me'
            subheader=''
          />
          
          <Box sx={styles.imageWrapper}>
            <Img fluid={fluid} />
            {/* <Button sx={styles.button}>Contact Me</Button> */}
          </Box>
         
        <Divider /> 
          <Flex sx={styles.grid}>
            <Box sx={styles.column}>
              <Section title='My Story'>
                <Text variant='p'>
                Self-introduction is a challenging task. 
                While you have to tell enough about yourself so that it gives enough context about you,
                you also need to be careful that it doesn't become a topic of self-bragging.
                Nevertheless, let me try.

                <hr />
                <b>Early Life and Education</b> <br />
                Hello, my name is Arvind Pandey.
                Born and brought up in a small village in Uttar Pradesh, India.
                I did my schooling in my village. 
                Fortunately, I got a good rank in AIEEE and moved to NIT Warangal to pursue engineering in Computer Science. <br /> <br />
                
                <b>Beginning of Corporate Life</b> <br />
                After graduating from college in April 2011.
                In June 2011, I joined CA Technologies, Hyderabad as Software Engineer.
                Life was good. Quite happy and proud but not for very long. 
                <br /><br />

                <b>Realization & Exploration</b> <br />

                Just after one year, it was in July 2012, I was sitting in the office on a weekend, bored.
                Self-reflecting on the last year, life was good except for one thing. 
                The curse of being a Software Engineer.
                Part of my job requires only to use my hand and probably a bit of my brain.
                I realized where I'm heading to. 
                I needed to step out of my comfort zone. I was looking for ways to engage in some form of activity.
                I came to know about a site called meetup.com from a friend.
                I started going trekking, bouldering, and rock climbing.
                I pursued it for a good one year. 
                It was fun but I was still not home. I kept looking for something more from life. 
                
                <br /><br />
                
                <b>Finding the home - The Running</b> <br />
                I came to know about Hyderabad Marathon in 2013, again from an office friend. 
                Signed-up for the full marathon. I signed up on July 16th, and the event was scheduled for August 31, Sunday. 
                I ran my first marathon unprepared. I almost died running 42.2 km [Not literally, but you get it]. 
                But, it changed me. I found my home. After that, I never stopped running.
                My first two marathons were full marathons, and it was painful as I was running and learning about running parallelly.
                Soon I started training regularly. My timing improved significantly.
                Since then, I have run numerous full marathons, and half marathons, and a couple of ultra marathons.
                <br />

                <b>My Personal Best:</b> <br />
                10k: 43 mins <br />
                21.1k: 1:41 hr <br />
                42.2k: 4:21 hr <br />

                <br />
                
                <b>The Current</b> <br />
                I moved to Bengaluru at the beginning of 2022.
                I'm working as Engineering Manager at The New Yorker [Condé Nast].
                I'm happy that my life is a balance between writing, running, gym, and job.
                I use this space to write essays and actionable steps on habits, productivity, and health.

                {/* <hr />

                If you found this space helpful, please consider showing your thanks by sponsoring me.
                
                <br />
                <br />
                <Button as={Link} to='https://www.buymeacoffee.com/arvindpandey' target="_blank"> Buy me a coffee </Button> */}

                <hr />
                </Text>
              </Section>
            </Box>
            {/*
            <Box sx={styles.column}>
              <Section title='Art Directing'>
                <Card variant='paper'>
                  During the brainstorming process, art directors, co-workers,
                  and clients are engaged in imagining what the finished piece
                  or scene might look like.
                </Card>
              </Section>
              <Divider />
              <Section title='Digital Marketing'>
                <Card variant='paper'>
                  Digital marketing channels are systems based on the Internet
                  that can create, accelerate, and transmit product value from
                  producer to a consumer terminal, through digital networks
                </Card>
              </Section>
              <Divider />
              <Section title='Creative Designing'>
                <Card variant='paper'>
                  A core responsibility of the designer's job is to present
                  information in a way that is both accessible and memorable.
                </Card>
              </Section>
            </Box>
            */}
          </Flex>
        </Main>
      </Stack>
    </Layout>
  )
}

const aboutQuery = graphql`
  query AboutQuery {
    photo: file(absolutePath: { regex: "/about.(jpeg|jpg|gif|png)/" }) {
      childImageSharp {
        fluid(maxWidth: 1140, maxHeight: 1200, cropFocus: NORTH) {
          ...GatsbyImageSharpFluid_noBase64
          width: presentationWidth
          height: presentationWidth
        }
      }
    }
  }
`
